import React, { useState } from 'react';
import classnames from 'classnames';
import validator from 'email-validator';
import CargomaticCard from 'components/v2/card';
import CargomaticInput from 'components/v2/input';
import CargomaticModal from 'components/v2/modal';
import CargomaticTooltip from 'components/v2/Tooltip';
import SessionStore from 'stores/SessionStore';
import { showToast } from 'stores/ToastStore';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import CarrierAccountAccess from './CarrierAccountAccess';
import CarrierAccountAccessConfirmationModal from './CarrierAccountAccessConfirmationModal';

const CarrierAssociatedAccounts = ({ className, onAccessRequest, userId }) => {
  const [emails, setEmails] = useState('');
  const [validEmails, setValidEmails] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const { t } = useTranslation();

  const handleOnEnter = (value) => {
    // CODE FOR UPCOMING MULTIPLE EMAILS FEATURE
    // const splitEmails = value.split(',');
    // if (splitEmails.length) {
    //   const emailsCheck = splitEmails.every((e) => {
    //     return validator.validate(e.trim());
    //   });
    //   setValidEmails(emailsCheck);
    // } else {
    //   setValidEmails(false);
    // }
    const toSelf = value.split(',').some((e) => {
      return e.trim() === SessionStore.getUser().email;
    });
    if (toSelf) {
      setValidEmails(false);
    } else {
      setValidEmails(validator.validate(value.trim()));
    }
    setEmails(value);
  };

  const newRequestIsValid = async (email) => {
    // validate if such request already exists
    const { data } = await UserWebAPIUtils.getAccountAccessRequests(userId);
    const existingRequests = data.filter(
      (req) => req.grantor_email === email.trim(),
    );
    if (existingRequests && existingRequests.length > 0) {
      showToast(t('PARTNER_ACCESS_ALREADY_REQUESTED'), null, 'error');
      return false;
    }
    return true;
  };

  const handleAccessRequest = async (emails) => {
    // CODE FOR UPCOMING MULTIPLE EMAILS FEATURE
    // const splitEmails = emails.split(',').map((e) => ({ email: e.trim() }));
    if (await newRequestIsValid(emails)) {
      const response = await onAccessRequest(emails);
      if (response.success) {
        setEmails('');
      }
    }
    setShowConfirmationModal(false);
  };

  return (
    <>
      <CargomaticCard
        header={() => (
          <header className="flex items-center space-x-1">
            <h3 className="my-0">{t('PARTNERS_ACCESS')}</h3>
            <CargomaticTooltip id="shipment_events">
              {t('PARTNERS_ACCESS_PRO_TIP')}
            </CargomaticTooltip>
          </header>
        )}
        className={classnames(className)}
      >
        <CarrierAccountAccess carrier={{ _id: userId }} />
        <div className="flex items-center">
          <CargomaticInput
            label={t('SEND_INVITE_TO_REQUEST_ACCESS')}
            value={emails}
            placeholder={titleize(t('EMAIL'))}
            className="w-72"
            inputClassNames="h-14"
            onChange={handleOnEnter}
          />
          <button
            type="submit"
            className="button button-green ml-8 mt-6"
            disabled={!validEmails}
            onClick={() => setShowConfirmationModal(true)}
          >
            {t('REQUEST_ACCESS')}
          </button>
        </div>
      </CargomaticCard>
      <CargomaticModal
        style={{ top: '35%' }}
        dialogClassName="rounded-xl border-4 border-green-cm w-1/4"
        showHeader={false}
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        body={
          <CarrierAccountAccessConfirmationModal
            handleCancelButtonClick={() => setShowConfirmationModal(false)}
            handleSubmitButtonClick={() => handleAccessRequest(emails)}
          />
        }
      />
    </>
  );
};

export default CarrierAssociatedAccounts;
